import React, { PureComponent } from 'react';
import TextField from 'material-ui/TextField';
import { inject } from 'mobx-react';

import classNames from 'classnames';

import HelpTooltip from './controls/helpTooltip';

@inject('translationsStore')
export default class PortalTextbox extends PureComponent {

    state = {
        contentVisible: this.props.type !== 'password'
    };
    inputRef = null;
    t = this.props.translationsStore.translate;


    componentDidMount() {
        if (this.inputRef && this.props.autoFocus)
            this.inputRef.focus();
    }

    handleContentVisibilityToggle = e => {
        if (this.inputRef)
            this.inputRef.focus();

        e.preventDefault();

        this.setState({ contentVisible: !this.state.contentVisible });
    };

    handleOnFocusCaretEndOfInput = (e) => {
        const tempValue = e.target.value;

        e.target.value = '';
        e.target.value = tempValue;
    };

    render() {

        const textboxBottomDefault = '#9b9b9b';
        const textboxBottomFocus = '#444444';
        const textboxBottomDisable = '#9B9B9B';

        const underlineStyle = {
            borderBottom: `1px solid ${ this.props.underlineColor || textboxBottomDefault }`
        };

        const underlineFocusStyle = {
            borderBottom: `1px solid ${ this.props.underlineFocusColor || textboxBottomFocus }`
        };

        const underlineDisabledStyle = {
            borderBottom: `1px solid ${ this.props.underlineDisabledColor || textboxBottomDisable }`,
            cursor: 'initial'
        };

        const floatingLabelStyle = {
            color: textboxBottomDefault,
            fontSize: '15px',
            fontWeight: 'normal',
            lineHeight: '17px'
        };

        const floatingLabelFocusStyle = {
            color: textboxBottomFocus,
            fontSize: '15px',
            fontWeight: 'normal'
        };

        const floatingLabelShrinkStyle = {
            color: textboxBottomDefault,
            fontSize: '15px',
            fontWeight: 'normal'
        };

        const shouldDisplayHelpTooltip = Boolean(this.props.helpTooltipText);
        const shouldTriggerHelpTooltipOnFocus = shouldDisplayHelpTooltip && Boolean(this.props.triggerHelpTooltipOnFocus);
        const helpTooltipId = `help-tooltip-${ Math.random().toString(36).substr(2, 9) }`;
        const textFieldHelpTooltipProps = shouldTriggerHelpTooltipOnFocus ? {
            'data-event': 'active focus',
            'data-for': shouldTriggerHelpTooltipOnFocus && helpTooltipId,
            'data-tip': true,
            'data-event-off': 'blur'
        } : {};

        const contentVisibilityToggle = this.props.includeContentVisibilityToggle && this.props.type === 'password' && !this.props.disabled ? (
            <button
                onClick={ this.handleContentVisibilityToggle }
                type='button'
                style={ {
                    position: 'absolute',
                    top: '54%',
                    right: shouldDisplayHelpTooltip && !shouldTriggerHelpTooltipOnFocus ? 15 : 0,
                    border: 'none',
                    background: 'transparent',
                    zIndex: 1
                } }>
                { this.state.contentVisible ? this.t('HIDE') : this.t('SHOW') }
            </button>
        ) : null;

        return (
            <div className="portal-textbox-wrapper" style={ { width: this.props.width } } data-cy={ this.props.dataCy }>
                <TextField
                    ref={ elem => (this.inputRef = elem) }
                    id={ this.props.id }
                    hintText={ this.props.hintText }
                    floatingLabelText={ this.props.floatingLabelText }
                    autoComplete={ this.props.autoComplete || 'off' }
                    className={ 
                                classNames(
                                  'portal-textbox',
                                  !shouldTriggerHelpTooltipOnFocus && 'textbox-help-tooltip',
                                  contentVisibilityToggle && 'content-visibility-toggle-button'
                                )
                              }
                    floatingLabelStyle={ floatingLabelStyle }
                    floatingLabelShrinkStyle={ floatingLabelShrinkStyle }
                    floatingLabelFocusStyle={ floatingLabelFocusStyle }
                    underlineStyle={ underlineStyle }
                    underlineFocusStyle={ underlineFocusStyle }
                    underlineDisabledStyle={ underlineDisabledStyle }
                    { ...textFieldHelpTooltipProps }
                    name="no-autocomplete"
                    onChange={ this.props.onChange }
                    onBlur={ this.props.onBlur }
                    onFocus={ this.handleOnFocusCaretEndOfInput }
                    errorText={ this.props.errorText }
                    data-cy={ this.props.dataCy || 'text-filed' }
                    errorStyle={ {
                        float: 'left',
                        fontSize: '13px',
                        color: '#D0021B'
                    } }
                    style={ {
                        width: '100%'
                    } }
                    type={ this.state.contentVisible ? 'text' : 'password' }
                    disabled={ this.props.disabled }
                    value={ this.props.value }
                />
                { contentVisibilityToggle }

                { shouldDisplayHelpTooltip ?
                  <HelpTooltip displayInline
                               placement={ this.props.helpTooltipPlacement || 'top' }
                               excludeIcon={ Boolean(shouldTriggerHelpTooltipOnFocus) }
                               id={ helpTooltipId }
                               text={ this.props.helpTooltipText } /> : null }
            </div>
        );
    }
}
